import makeStyles from '@mui/styles/makeStyles'
import { Theme } from '@mui/material'

const useStyles = makeStyles(theme => ({
  root: {
    '& *': {
      border: 'none !important',
      outline: 'none !important'
    }
  },

  mention: {
    zIndex: '1',
    position: 'relative',
    padding: '0.0625rem',
    borderRadius: '0.5rem',
    color: 'white',
    pointerEvents: 'none',
    background: theme.palette.primary.main
  },

  tagMention: {
    zIndex: '1',
    position: 'relative',
    padding: '0.0625rem',
    borderRadius: '0.5rem',
    color: 'white',
    pointerEvents: 'none',
    backgroundColor: theme.palette.secondary.main
  }
}))

const HEIGHT = '4rem'
const HALF_HEIGHT = '2rem'

export const inputStyle = (theme: Theme) => ({
  control: {
    backgroundColor: '#fff',
    fontSize: theme.size.sm,
    color: '#888888'
  },

  '&multiLine': {
    control: {
      height: HEIGHT,
      backgroundColor: 'transparent'
    },

    highlighter: {
      boxSizing: 'border-box',
      height: HEIGHT,
      padding: '0.25rem',
      overflow: 'hidden'
    },

    input: {
      border: 'none',
      height: '100%',
      padding: '0.25rem',
      overflowY: 'auto'
    }
  },

  '&singleLine': {
    control: {
      height: HALF_HEIGHT,
      backgroundColor: 'transparent'
    },

    highlighter: {
      boxSizing: 'border-box',
      height: HALF_HEIGHT,
      padding: '0.5rem 0',
      overflow: 'hidden'
    },

    input: {
      border: 'none',
      overflow: 'auto hidden',
      padding: '0.5rem 0'
    }
  },

  suggestions: {
    list: {
      border: '0.0625rem solid rgba(0,0,0,0.15)',
      backgroundColor: 'white',
      fontSize: theme.size.base
    },

    item: {
      borderBottom: '0.0625rem solid rgba(0,0,0,0.15)',
      padding: '0.3125rem 0.9375rem',
      color: 'black',

      '&focused': {
        backgroundColor: '#cee4e5'
      }
    }
  }
})

export default useStyles
